import { Fragment, FunctionComponent } from "react";
import { Button, ButtonClass } from "@pjs/core-ui";
import { useOnMount } from "@pjs/react-utilities";
import { actionLogger } from "@pjs/a11y";
import { userUiI18n } from "../i18n/UserUiI18n.const";
import { IAccountSettingsDashboardProps } from "./interfaces/IAccountSettingsDashboardProps";
import { SettingsSidebar } from "./SettingsSidebar.component";
import { SettingsView } from "./SettingsView.component";
import "./styles/account-settings-dashboard.css";

export const AccountSettingsDashboard: FunctionComponent<IAccountSettingsDashboardProps> = (props) => {
    useOnMount(() => {
        actionLogger.append(userUiI18n.getString("account_settings_dashboard.loaded"));
    });

    return (
        <section aria-label={userUiI18n.getString("account_settings_dashboard.title")}>
            <h1 className="uui-account-settings-dashboard__title" tabIndex={-1} id="skip-to-content-header">
                {userUiI18n.getString("account_settings_dashboard.title")}
            </h1>
            <div className="uui-account-settings-dashboard">
                <Fragment>
                    <SettingsSidebar
                        availableViews={props.availableViews}
                        activeView={props.activeView}
                        setView={props.setView}
                        hideSidebar={props.activeView !== null}
                    />
                    {props.activeView !== null && (
                        <Fragment>
                            <div className="uui-account-settings-dashboard__back">
                                <Button onClick={props.back} className={ButtonClass.Outlined}>
                                    {userUiI18n.getString("account_settings_dashboard.back")}
                                </Button>
                            </div>
                            <SettingsView activeView={props.activeView} />
                        </Fragment>
                    )}
                </Fragment>
            </div>
        </section>
    );
};
